import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function OfferSection() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <section id="offer" className="py-24 px-4 sm:px-6 lg:px-8 bg-sage relative overflow-hidden" data-id="element-64">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-65"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-cream/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2 pointer-events-none" data-id="element-66"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-[#3A4A3E] rounded-3xl p-8 sm:p-12 md:p-16 text-center shadow-2xl border border-gold/20" data-id="element-68">
          <h2 className="text-3xl sm:text-4xl font-serif text-cream mb-6" data-id="element-69">
            Obtén el Ebook
          </h2>

          <div className="my-10" data-id="element-70">
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-71">
              <span className="text-2xl sm:text-3xl font-sans text-cream/40 line-through decoration-2" data-id="element-72">
                $28 USD
              </span>
              <span className="inline-block bg-terracotta text-cream text-sm sm:text-base font-semibold px-3 py-1 rounded-full" data-id="element-73">
                -71% OFF
              </span>
            </div>
            <span className="text-6xl sm:text-7xl font-serif text-gold font-medium tracking-tight" data-id="element-74">
              $8{' '}
              <span className="text-2xl sm:text-3xl font-sans text-gold/80" data-id="element-75">
                USD
              </span>
            </span>
          </div>

          <p className="text-cream/80 text-lg sm:text-xl mb-12 max-w-xl mx-auto font-light" data-id="element-76">
            Un solo pago para transformar los tres lugares más importantes de tu
            casa, donde pasas el 90% de tu tiempo.
          </p>

          <motion.div whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.98
        }} className="inline-block w-full sm:w-auto" data-id="element-77">
            <a href="https://www.impresso-shop.com/cart/43103322701890:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            if (window.fbq) {
              window.fbq('track', 'AddToCart');
            }
          }} className="block w-full px-8 py-5 text-lg sm:text-xl font-medium text-charcoal bg-gold rounded-full shadow-[0_0_30px_rgba(184,134,11,0.4)] hover:shadow-[0_0_40px_rgba(184,134,11,0.6)] transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold focus:ring-offset-[#3A4A3E]" aria-label="Desbloquea mi hogar ahora por 27 dólares" data-id="element-78">
              DESBLOQUEA MI HOGAR AHORA
            </a>
          </motion.div>

          <p className="mt-6 text-cream/60 text-sm sm:text-base" data-id="element-79">
            Acceso inmediato post-pago. 100% digital.
          </p>
        </motion.div>
      </div>

      {/* Footer */}
      <footer className="mt-24 text-center border-t border-cream/10 pt-8 relative z-10" data-id="element-80">
        <p className="text-cream/50 text-sm" data-id="element-81">
          &copy; {new Date().getFullYear()} Aprende Feng Shui con Janeth
          Schmidt. Todos los derechos reservados.
        </p>
        <div className="mt-4 flex items-center justify-center gap-4 text-sm" data-id="element-82">
          <button onClick={() => setActiveModal('privacy')} className="text-cream/40 hover:text-cream/70 transition-colors duration-200 underline underline-offset-2" data-id="element-83">
            Política de Privacidad
          </button>
          <span className="text-cream/20" data-id="element-84">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-cream/40 hover:text-cream/70 transition-colors duration-200 underline underline-offset-2" data-id="element-85">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {/* Legal Modal */}
      <AnimatePresence data-id="element-86">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-charcoal/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-87">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="bg-cream rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-88">
              <div className="sticky top-0 bg-cream rounded-t-2xl border-b border-charcoal/10 px-6 py-4 flex items-center justify-between" data-id="element-89">
                <h3 className="text-xl font-serif font-medium text-charcoal" data-id="element-90">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-charcoal/40 hover:text-charcoal transition-colors duration-200 text-2xl leading-none p-1" aria-label="Cerrar" data-id="element-91">
                  &times;
                </button>
              </div>

              <div className="px-6 py-6 text-charcoal/80 text-sm leading-relaxed space-y-4" data-id="element-92">
                {activeModal === 'privacy' ? <>
                    <p data-id="element-93">
                      <strong data-id="element-94">Última actualización:</strong> Marzo 2026
                    </p>
                    <p data-id="element-95">
                      En Aprende Feng Shui con Janeth Schmidt, respetamos tu
                      privacidad y nos comprometemos a proteger tu información
                      personal.
                    </p>
                    <h4 className="text-base font-semibold text-charcoal mt-4" data-id="element-96">
                      Información que recopilamos
                    </h4>
                    <p data-id="element-97">
                      Recopilamos únicamente la información que nos proporcionas
                      voluntariamente al realizar una compra, como tu nombre y
                      correo electrónico, con el fin de entregarte el producto
                      digital adquirido.
                    </p>
                    <h4 className="text-base font-semibold text-charcoal mt-4" data-id="element-98">
                      Uso de la información
                    </h4>
                    <p data-id="element-99">
                      Tu información se utiliza exclusivamente para procesar tu
                      compra y enviarte el acceso al contenido adquirido. No
                      compartimos, vendemos ni cedemos tus datos a terceros.
                    </p>
                    <h4 className="text-base font-semibold text-charcoal mt-4" data-id="element-100">
                      Seguridad
                    </h4>
                    <p data-id="element-101">
                      Implementamos medidas de seguridad razonables para
                      proteger tu información personal contra acceso no
                      autorizado o alteración.
                    </p>
                    <h4 className="text-base font-semibold text-charcoal mt-4" data-id="element-102">
                      Tus derechos
                    </h4>
                    <p data-id="element-103">
                      Puedes solicitar la eliminación de tus datos personales en
                      cualquier momento. Nos reservamos el derecho de actualizar
                      esta política según sea necesario.
                    </p>
                  </> : <>
                    <p data-id="element-104">
                      <strong data-id="element-105">Última actualización:</strong> Marzo 2026
                    </p>
                    <p data-id="element-106">
                      Al adquirir cualquier producto digital de Aprende Feng
                      Shui con Janeth Schmidt, aceptas los siguientes términos y
                      condiciones.
                    </p>
                    <h4 className="text-base font-semibold text-charcoal mt-4" data-id="element-107">
                      Producto digital
                    </h4>
                    <p data-id="element-108">
                      Este es un producto 100% digital. Una vez realizado el
                      pago, recibirás acceso inmediato al contenido. Debido a la
                      naturaleza digital del producto, no se aceptan
                      devoluciones.
                    </p>
                    <h4 className="text-base font-semibold text-charcoal mt-4" data-id="element-109">
                      Uso personal
                    </h4>
                    <p data-id="element-110">
                      El contenido adquirido es para uso personal y no puede ser
                      reproducido, distribuido ni compartido sin autorización
                      previa por escrito.
                    </p>
                    <h4 className="text-base font-semibold text-charcoal mt-4" data-id="element-111">
                      Resultados
                    </h4>
                    <p data-id="element-112">
                      Los resultados pueden variar según cada persona y su
                      aplicación del contenido. No garantizamos resultados
                      específicos.
                    </p>
                    <h4 className="text-base font-semibold text-charcoal mt-4" data-id="element-113">
                      Modificaciones
                    </h4>
                    <p data-id="element-114">
                      Nos reservamos el derecho de modificar estos términos en
                      cualquier momento. Las modificaciones serán efectivas
                      desde su publicación.
                    </p>
                  </>}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}